
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 132172","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 132181","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M10.85 23.531h-.6c-4.835 0-7.25-1.208-7.25-7.246v-6.039Q3 3 10.246 3h9.662q7.246 0 7.246 7.246v6.039q0 7.246-7.246 7.246h-.6a1.224 1.224 0 00-.966.483l-1.816 2.416a1.716 1.716 0 01-2.9 0l-1.81-2.416a1.365 1.365 0 00-.966-.483z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.039 10.246h12.077M9.039 16.285h7.246"}})])])
          )
        }
      }
    